import CACHE_KEYS from '../../constants/cache-keys'

const useCacheKeys = () => {
    return CACHE_KEYS
}

export default useCacheKeys